import React from "react";

import { useAppSelector } from "store";
import { selectComparatorsByChapter } from "modules/customer/tools/location/locationSlice";
import { RetailComplexionSeries, selectRetailComplexionSeries, setRetailComplexionSeries } from "modules/customer/tools/location/retailers/retailersSlice";
import ToggleButton from "components/filters/ToggleButton";
import { Typography } from "@material-ui/core";

const RetailComplexionSeriesToggle: React.FC = () => {
    const comparator = useAppSelector(selectComparatorsByChapter)?.retailers;
    const retailComplexionSeries = useAppSelector(selectRetailComplexionSeries);
    return (
        <>
            <Typography variant="h6" component="div" gutterBottom>
                Brand mix in the Retail Zone
            </Typography>
            <ToggleButton<RetailComplexionSeries>
                currentValue={retailComplexionSeries}
                primaryValue="Pinned Location"
                primaryValueLabel="Selected location"
                secondaryValue="Comparator"
                secondaryValueLabel={`${comparator?.storeName} store`}
                setChosenValue={setRetailComplexionSeries}
            />
        </>
    );
};

export default RetailComplexionSeriesToggle;
